import { jsx } from 'react/jsx-runtime';
import { s as styles } from '../../../../Symbol.module-CLfqmFso.mjs';

const SymbolSize20 = () => {
  return jsx("svg", { className: styles.root, width: "20", height: "20", "data-testid": "ZapierLogoSymbolSmall", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: jsx("rect", { width: "20", height: "20", rx: "3", fill: "#FF4F00" }) });
};

export { SymbolSize20 };
//# sourceMappingURL=SymbolSize20.es.js.map
